import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IsLoginComponent } from './is-login.component';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { TranslateModule } from '@ngx-translate/core';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatTooltipModule } from '@angular/material/tooltip';

@NgModule({
    declarations: [
        IsLoginComponent
    ],
    exports: [
        IsLoginComponent
    ],
    imports: [
        CommonModule,
        MatButtonModule,
        FormsModule,
        ReactiveFormsModule,
        MatIconModule,
        MatInputModule,
        MatProgressSpinnerModule,
        TranslateModule,
        MatFormFieldModule,
        MatTooltipModule
    ],
    providers: [provideHttpClient(withInterceptorsFromDi())]
})
export class IsLoginModule { }
